<router-outlet class="bg-primary"></router-outlet>
